import { render, staticRenderFns } from "./TheCreateWalletLayout.vue?vue&type=template&id=24a082ae"
import script from "./TheCreateWalletLayout.vue?vue&type=script&lang=js"
export * from "./TheCreateWalletLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports